import {SET_ONBOARDING_VIDEO_STATE} from "actions/onboardingVideo";

const defaultState = Object.freeze({
  state: 'unstarted'
});

export default function reducer(state = defaultState, action) {
  switch(action.type) {
    case SET_ONBOARDING_VIDEO_STATE: {
      return {...state, state: action.payload}
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/onboardingVideo.js